import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const checkoutAdminAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AdminPanel],
}
